
import React, { Fragment, useMemo, useState } from 'react'
import { Button, Col, FormGroup, FormLabel, Modal, Row } from 'react-bootstrap'

import AddICon from '../../../SvgImages/Add'

import './CostCreator.scss'
import useTranslation from '@/Hooks/UseTranslation'
import InputText from '../../components/InputText'
import InputSelect from '../../components/InputSelect'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import { addCost } from '@/Services/ProgrammationManagerService'

const CostCreator = () => {

  const { t } = useTranslation()

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const [ showModal, setShowModal ] = useState(false)

  const [ type, setType ] = useState('labor')
  const [ description, setDescription ] = useState('')
  const [ unit, setUnit ] = useState('')
  const [ crewNumber, setCrewNumber ] = useState(0)
  const [ quantity, setQuantity ] = useState(0)
  const [ unitPrice, setUnitPrice ] = useState(0)

  const [ creating, setCreating ] = useState(false)

  const partial = useMemo(() => {

    if (type === 'labor') {

      return crewNumber * quantity * unitPrice
    }

    if (type === 'material') {

      return quantity * unitPrice
    }

    if (type === 'tool') {

      return quantity * unitPrice
    }

    return 0
  }, [ type, crewNumber, quantity, unitPrice ])

  const isDisabled = useMemo(() => {

    if (type === 'labor') {

      return !description || !unit || !crewNumber || !quantity || !unitPrice
    }

    if (type === 'material') {

      return !description || !unit || !quantity || !unitPrice
    }

    if (type === 'tool') {

      return !description || !unit || !quantity || !unitPrice
    }
  }, [ type, description, unit, crewNumber, quantity, unitPrice ])

  const handleCreateCost = async () => {
    setCreating(true)
    setEditingItem(true)

    const [ error, data ] = await addCost(itemOpened._id, {
      type,
      description,
      unit,
      crewNumber,
      quantity,
      unitPrice,
      partial,
    })

    setCreating(false)
    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    setDescription('')
    setUnit('')
    setCrewNumber(0)
    setQuantity(0)
    setUnitPrice(0)

    patchItemOpened({
      resources: [...itemOpened.resources, data.resource]
    })

    setShowModal(false)
  }

  return (
    <Fragment>
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className='mb-2'
      >
        <AddICon fill="#fff" height={24} width={24} />
      </Button>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdropClassName='cost-creator-backdrop'
        className='cost-creator'
      >
        <Modal.Header>
          <Modal.Title>
            {t('COSTS_CREATOR:Title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <FormLabel>
              {t('COSTS_CREATOR:DescriptionLabel')}
            </FormLabel>
            <InputText
              value={description}
              onChange={setDescription}
            />
          </FormGroup>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <FormLabel>
                  {t('COSTS_CREATOR:TypeLabel')}
                </FormLabel>
                <InputSelect
                  value={type}
                  onChange={setType}
                  options={[
                    { _id: 'labor', name: t('COSTS_CREATOR:TypeLabor') },
                    { _id: 'material', name: t('COSTS_CREATOR:TypeMaterial') },
                    { _id: 'tool', name: t('COSTS_CREATOR:TypeTool') },
                  ]}
                />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <FormLabel>
                  {t('COSTS_CREATOR:UnitLabel')}
                </FormLabel>
                <InputText
                  value={unit}
                  onChange={setUnit}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              {type === 'labor' && (
                <FormGroup>
                  <FormLabel>
                    {t('COSTS_CREATOR:CrewNumberLabel')}
                  </FormLabel>
                  <InputText
                    value={crewNumber.toString()}
                    onChange={(val: string) => setCrewNumber(Number(val))}
                  />
                </FormGroup>
              )}
            </Col>
            <Col sm={4}>
              <FormGroup>
                <FormLabel>
                  {t('COSTS_CREATOR:QuantityLabel')}
                </FormLabel>
                <InputText
                  value={quantity.toString()}
                  onChange={(val: string) => setQuantity(Number(val))}
                />
              </FormGroup>
            </Col>
            <Col sm={4}>
              <FormGroup>
                <FormLabel>
                  {t('COSTS_CREATOR:UnitPriceLabel')}
                </FormLabel>
                <InputText
                  value={unitPrice.toString()}
                  onChange={(val: string) => setUnitPrice(Number(val))}
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup style={{ textAlign: 'right', marginBottom: '1rem' }}>
            <FormLabel style={{ fontWeight: 'bold', fontSize: '1rem' }}>
              {t('COSTS_CREATOR:PartialLabel')}: {partial.toString()}
            </FormLabel>
          </FormGroup>
          <Row>
            <Col style={{ textAlign: 'right' }}>
              <Button
                variant='primary'
                onClick={() => handleCreateCost()}
                disabled={isDisabled}
              >
                <AddICon fill="#fff" height={24} width={24} />{' '}
                {!creating && t('COST_CREATOR:AddButton')}
                {creating && t('COST_CREATOR:AddButtonAdding')}
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </Fragment>
  )
}

export default CostCreator
